import React from 'react';
import ReactDOM from 'react-dom';
import '../src/css/body.css';
import OnLoad from './js/app.jsx'


const root = document.querySelector("body");




ReactDOM.render(<OnLoad></OnLoad>,root);

